<template>
  <v-container>
    <h3>TeamWaizmann Experten-Webinare </h3>
<v-row>
  <v-col cols="12" md="9">
    <component :is="currentComponent"  class="my-4"/>
    <div v-if="isLoading" class="termine-loader my-6">
      <v-progress-circular
        indeterminate
        color="primary"
        size="24"
        width="3"
      />
      <span>Termine werden geladen...</span>
    </div>
    <span v-else-if="webinare.length > 0">
      <h2 class="my-4">Termine für dieses Webinar: </h2>
   
    <div v-for="webinar in webinare" :key="webinar.wter_id" >
      <WebinarView  :webinar="webinar" class="mb-12"/>
    </div>
    </span>
    <span v-else>
      <p>Es gibt keine Webinare für dieses Thema</p>
    </span>
  </v-col>
  <v-col v-if="dozentDesc" cols="12" md="3">
    <div class="dozent-desc-card">
      <h4>Dozenteninfo</h4>
      <img
        v-if="dozentImage"
        :src="dozentImage"
        alt="Dozent"
        class="dozent-image"
      />
      <div class="dozent-desc-content" v-html="dozentDesc"></div>
    </div>
  </v-col>
</v-row>
  </v-container>
</template>

<script setup>
import { inject, ref, onMounted, computed,defineAsyncComponent } from 'vue'
import WebinarView from '@/components/objects/webinar/WebinarView.vue'
import { useRoute } from 'vue-router'


const route = useRoute();

const baseCalls = inject('baseCalls')
const updateDocumentHead = inject('updateDocumentHead');

const webinare = ref([])
const webinar = ref(false)
const isLoading = ref(false)

const currentComponent = computed(() => {
  const id = route.params.id;
  if (id) {
    return defineAsyncComponent(() =>
      import(`@/components/sites/objects/webinare/Webinar${id}View.vue`)
    );
  }
  return null; // Fallback, falls id nicht vorhanden ist
});

const dozentDesc = computed(() => {
  const desc = webinar.value?.dozent_desc
  if (!desc || !String(desc).trim()) {
    return ''
  }
  return String(desc).trim()
})

const dozentImage = computed(() => {
  const raw = webinar.value?.dozent_image
  if (!raw || !String(raw).trim()) {
    return ''
  }

  const value = String(raw).trim()
  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('/')) {
    return value
  }

  const normalized = value
    .replace(/^\.?\//, '')
    .replace(/^assets\/site\//, '')
    .replace(/^site\//, '')

  try {
    return require('@/assets/site/' + normalized)
  } catch (err) {
    console.log('Dozentenbild konnte nicht aufgelöst werden:', value, err)
    return ''
  }
})

async function getWebinare() {
  isLoading.value = true
  let data = {
    action: 'getwebinareid',
    id: route.params.id
  }
  try {
    const response = await baseCalls.webinareGet(data)
    if (response.data.webinare) {
      webinare.value = response.data.webinare
      webinar.value = response.data.webinare[0]
      updateDocumentHead(
      webinar.value.title,
     'TeamWaizmann Praxis-Webinar | ' + webinar.value.title
    ) 
    }
  } finally {
    isLoading.value = false
  }
}

onMounted(async () => {
  getWebinare()

})
</script>

<style scoped>
.dozent-desc-card {
  background: #f7f9fc;
  border-radius: 12px;
  border: 1px solid #e1e6ef;
  padding: 16px;
}

.dozent-desc-card h4 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: #1f3a63;
}

.dozent-desc-content {
  color: #3e4a66;
  line-height: 1.45;
  white-space: pre-line;
}

.dozent-image {
  width: 100%;
  max-width: 240px;
  height: auto;
  border-radius: 8px;
  border: 1px solid #d7deea;
  background: #fff;
  margin-bottom: 12px;
}

.termine-loader {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #4a5568;
  background: #f7f9fc;
  border: 1px solid #e1e6ef;
  border-radius: 10px;
  padding: 12px 16px;
}
</style>